import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/insights/retailer-rates')({
  staticData: toStaticData(CRT_ROUTES['/crt/pricing-excise/insights/retailer-rates']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
